module.exports = __webpack_public_path__ + "static/img/sp15.eef912a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sp15.jpg
// module id = hwvA
// module chunks = 0